import React, { useEffect } from 'react';
import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import { isValidObject } from 'common/utilities/utils';
import { GET_ORDER_STATUS_MAX_RETRY_COUNT } from '@kfc-global/react-shared/config/config.constants';
import { config } from '@kfc-global/react-shared/config/config.utils';

const getOrderProcessingProgressBarView = props => {
  return (
    <LazyLoaderWrapper
      {...props}
      testId='order_processing_progress_bar_view'
      importPath='ORDER_PROCESSING_PROGRESS_BAR_VIEW'
    ></LazyLoaderWrapper>
  );
};

const OrderProcessingProgressBar = props => {
  const { orderDetails } = props;
  const { retryCountForGetOrderStatus } = orderDetails;

  useEffect(() => {
    if (retryCountForGetOrderStatus >= 0 && retryCountForGetOrderStatus <= config(GET_ORDER_STATUS_MAX_RETRY_COUNT)) {
      const progressBarContainer = document.getElementById('progressBarContainer');
      const progressBar = document.getElementById('progressBar');
      if (progressBarContainer && progressBar) {
        const width =
          (progressBarContainer?.offsetWidth / config(GET_ORDER_STATUS_MAX_RETRY_COUNT)) *
          (retryCountForGetOrderStatus + 1);
        if (isValidObject(progressBar?.style)) {
          progressBar.style.width = width + 'px';
        }
      }
    }
  }, [retryCountForGetOrderStatus]);

  return getOrderProcessingProgressBarView(props);
};

export default OrderProcessingProgressBar;
